import { useRef, useState, useEffect } from 'react';
import { gsap } from 'gsap';

//* Style
import GalleryStyle from './style';

//* Component
import CustomImage from '@/components/CustomImage';

const Gallery = ({ data, loading }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [isAnimating, setIsAnimating] = useState(false);
	const [loadImage, setLoadImage] = useState(false);

	const trackRef = useRef();
	const leftBarWrap = useRef();
	const firstSlideRef = useRef();

	const handleClick = (ind) => {
		if (ind === activeIndex || isAnimating) return;

		setIsAnimating(ind);

		gsap.set(trackRef.current, { x: 0 });

		gsap.to(trackRef.current, {
			x: (trackRef.current.offsetWidth + 8) * -1,
			duration: 0.5,
			ease: 'linear',
			onComplete: () => {
				setTimeout(() => {
					setActiveIndex(ind);
					gsap.set(trackRef.current, { x: 0 });
					setIsAnimating(null);
				}, 60);
			},
		});
	};

	useEffect(() => {
		if (leftBarWrap.current?.children && loadImage) {
			loading(true);
			const children = leftBarWrap.current.children;

			gsap.fromTo(firstSlideRef.current.children[0], { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power2.in' });
			gsap.fromTo(firstSlideRef.current.children[0], { y: '50%' }, { y: 0, duration: 0.8, ease: 'power2.out' });

			gsap.fromTo(children, { scale: 0, opacity: 1 }, { scale: 1, duration: 0.9, ease: 'power2.out', stagger: 0.12, delay: 0.6 });
		}
	}, [loadImage]);

	return (
		<GalleryStyle>
			<div className='gallery-root'>
				<div
					ref={leftBarWrap}
					className='gallery-left-bar'>
					{data.map((item, i) => (
						<div
							key={i}
							className={`opacity-zero gallery-thumb ${i === activeIndex ? ' active' : ''} ${
								typeof isAnimating == 'number' ? 'animating' : ''
							} wrap-image`}
							onClick={() => handleClick(i)}>
							<CustomImage
								src={item.src}
								alt={item.alt}
								className='gallery-img'
							/>
						</div>
					))}
				</div>
				<div className='gallery-content'>
					<div
						ref={trackRef}
						className={`gallery-track ${typeof isAnimating == 'number' ? ' animating' : ''}`}>
						<div
							ref={firstSlideRef}
							className='gallery-slide'>
							<CustomImage
								onLoad={setLoadImage}
								src={data[activeIndex].src}
								alt={data[activeIndex].alt}
								className='gallery-img opacity-zero'
							/>
						</div>
						{typeof isAnimating == 'number' && (
							<div className='gallery-slide gallery-img-track'>
								<CustomImage
									src={data[isAnimating].src}
									alt={data[isAnimating].alt}
									className='gallery-img'
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</GalleryStyle>
	);
};

export default Gallery;
